<div class="company-chart welldone-card" *ngIf="!chartReady">
    <div class="company-chart-skel">
        <div class="company-skel company-chart-skel-title"></div>
        <div class="company-chart-skel-bars">
            <div class="company-skel company-chart-skel-bar" *ngFor="let bar of chartSkeletonBars" [style.height]="bar"></div>
        </div>
    </div>
</div>
<div class="company-chart welldone-card" *ngIf="chartReady">
    <apx-chart
        [series]="chartOptions.series"
        [chart]="chartOptions.chart"
        [dataLabels]="chartOptions.dataLabels"
        [plotOptions]="chartOptions.plotOptions"
        [yaxis]="chartOptions.yaxis"
        [xaxis]="chartOptions.xaxis"
        [fill]="chartOptions.fill"
        [title]="chartOptions.title"
        [tooltip]="chartOptions.tooltip"
    ></apx-chart>
</div>

<ng-container *ngIf="!alternativeTable; else componentPage">
    <ui-table #companiesTable [table-title]="'Società in attesa di attivazione'"
              [table-description]="'In questa lista ci sono tutte le società che hanno completato il boarding e una volta ricevuto il pagamento possiamo attivare.'">
        <ng-template #customHeader>
            <tr>
                <th>Ragione Sociale</th>
                <th>Data boarding</th>
                <th>Agente</th>
                <th>Stato pagamento</th>
                <th scope="col" class="d-flex justify-content-end pe-5"> Azioni</th>
            </tr>
        </ng-template>
        <ng-template #customRow let-row="row">
            <tr>
                <td> {{ row.name }}</td>
                <td> {{ formatDateForTable(row.createdAt) }}</td>
                <td> {{ row.agentId ?? 'Nessun agente' }}</td>
                <td>
                    <div class="badge badge-success"> {{ translateStatus(row.status) }}</div>
                </td>
                <td>
                    <div class="d-flex justify-content-end">
                        <button class="btn btn-light me-2">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                 class="bi bi-pencil" viewBox="0 0 16 16">
                                <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"/>
                            </svg>
                        </button>
                        <button class="btn btn-light ">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                 class="bi bi-trash" viewBox="0 0 16 16">
                                <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6Z"/>
                                <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1ZM4.118 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118ZM2.5 3h11V2h-11v1Z"/>
                            </svg>
                        </button>
                    </div>
                </td>
            </tr>
        </ng-template>
    </ui-table>
</ng-container>

<ng-template #componentPage>
    <div class="company-roster">
        <header class="company-roster-head">
            <div class="company-roster-copy">
                <h1>Società iscritte</h1>
                <p>Anagrafica delle società, stato di onboarding e abbonamenti sulla piattaforma.</p>
            </div>
            <span class="company-roster-count" *ngIf="!loading">{{ totalRecords }} società</span>
        </header>

        <form class="company-roster-toolbar" (submit)="$event.preventDefault(); applyFilters()">
            <input
                type="search"
                class="form-control form-control-solid"
                [(ngModel)]="textFilter"
                name="companySearch"
                placeholder="Cerca nome, dominio o P. IVA"
                (keyup.enter)="applyFilters()"
            />
            <button
                type="button"
                class="btn welldone-btn-gray user-filter-trigger"
                [class.is-open]="!!activeFilterCount"
                (click)="filtersPanel.toggle($event)"
            >
                <i class="bi bi-funnel" aria-hidden="true"></i>
                Filtri
                <span class="user-filter-badge" *ngIf="activeFilterCount">{{ activeFilterCount }}</span>
            </button>
            <button type="submit" class="btn btn-primary">Cerca</button>
            <button type="button" class="btn btn-reset-link" *ngIf="hasActiveQuery" (click)="resetAll()">Reset</button>
        </form>

        <button
            type="button"
            class="company-month-chip"
            *ngIf="monthFilterLabel"
            (click)="filterByMonth(selectedMonth!, selectedYear!)"
        >
            {{ monthFilterLabel }}
            <i class="bi bi-x-lg" aria-hidden="true"></i>
        </button>

        <p-overlayPanel #filtersPanel [dismissable]="false" styleClass="user-filter-popover">
            <div class="user-filter-form">
                <div class="user-filter-field">
                    <label class="form-label" for="company-status">Stato</label>
                    <p-multiSelect
                        inputId="company-status"
                        styleClass="wisper-multiselect"
                        panelStyleClass="wisper-multiselect-panel"
                        [options]="statusOptions"
                        [(ngModel)]="selectedStatusIds"
                        optionLabel="name"
                        optionValue="id"
                        placeholder="Tutti"
                        display="chip"
                        [showToggleAll]="false"
                        [style]="{'width':'100%'}"
                        appendTo="body"
                    ></p-multiSelect>
                </div>

                <div class="user-filter-field" *ngIf="!lockedAgentId">
                    <label class="form-label" for="company-agent">Agente</label>
                    <p-multiSelect
                        inputId="company-agent"
                        styleClass="wisper-multiselect"
                        panelStyleClass="wisper-multiselect-panel"
                        [options]="agents"
                        [(ngModel)]="selectedAgentIds"
                        optionLabel="name"
                        optionValue="id"
                        placeholder="Tutti"
                        display="chip"
                        [filter]="true"
                        filterPlaceHolder="Cerca agente"
                        [showToggleAll]="true"
                        [resetFilterOnHide]="true"
                        [disabled]="noAgent"
                        emptyFilterMessage="Nessun risultato"
                        selectedItemsLabel="{0} agenti"
                        [maxSelectedLabels]="2"
                        [style]="{'width':'100%'}"
                        appendTo="body"
                    ></p-multiSelect>
                </div>

                <div class="user-filter-field">
                    <label class="form-label" for="company-period">Periodo abbonamento</label>
                    <p-multiSelect
                        inputId="company-period"
                        styleClass="wisper-multiselect"
                        panelStyleClass="wisper-multiselect-panel"
                        [options]="periodOptions"
                        [(ngModel)]="selectedPeriods"
                        optionLabel="name"
                        optionValue="id"
                        placeholder="Tutti"
                        display="chip"
                        [showToggleAll]="false"
                        [style]="{'width':'100%'}"
                        appendTo="body"
                    ></p-multiSelect>
                </div>

                <div class="user-filter-field">
                    <label class="form-label" for="company-sort">Ordina per</label>
                    <p-dropdown
                        inputId="company-sort"
                        styleClass="wisper-select"
                        panelStyleClass="wisper-select-panel"
                        [options]="sortOptions"
                        [(ngModel)]="sortBy"
                        optionLabel="name"
                        optionValue="id"
                        [style]="{'width':'100%'}"
                        appendTo="body"
                    ></p-dropdown>
                </div>

                <label class="user-filter-switch">
                    <span>Solo senza dominio</span>
                    <p-inputSwitch [(ngModel)]="noDomain"></p-inputSwitch>
                </label>

                <label class="user-filter-switch" *ngIf="!lockedAgentId">
                    <span>Solo senza agente</span>
                    <p-inputSwitch [(ngModel)]="noAgent" (ngModelChange)="onNoAgentChange($event)"></p-inputSwitch>
                </label>

                <div class="user-filter-actions">
                    <button type="button" class="btn btn-reset-link" (click)="clearAdvancedFilters()">Azzera</button>
                    <button type="button" class="btn btn-primary" (click)="applyFilters()">Applica</button>
                </div>
            </div>
        </p-overlayPanel>

        <p-table
            [value]="companies"
            dataKey="id"
            [lazy]="true"
            [paginator]="true"
            [rows]="rows"
            [first]="first"
            [totalRecords]="totalRecords"
            [loading]="loading"
            [rowsPerPageOptions]="[30,50,100]"
            [rowHover]="true"
            responsiveLayout="scroll"
            styleClass="company-roster-table"
            paginatorDropdownAppendTo="body"
            currentPageReportTemplate="{first}–{last} di {totalRecords}"
            [showCurrentPageReport]="true"
            (onLazyLoad)="loadCompanies($event)"
        >
            <ng-template pTemplate="header">
                <tr>
                    <th>Società</th>
                    <th>Agente</th>
                    <th>Stato</th>
                    <th>Abbonamento</th>
                    <th class="company-col-actions">Azioni</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
                <tr class="company-roster-row" (click)="openCompany(row)">
                    <td>
                        <div class="company-identity">
                            <app-identity-avatar
                                [imageUrl]="row.logoUrl"
                                [initials]="row.name?.trim().charAt(0).toUpperCase() || '?'"
                                [colorKey]="row.id || row.name || ''"
                            ></app-identity-avatar>
                            <div class="company-identity-text">
                                <span class="company-name">{{ row.name }}</span>
                                <span class="company-domain">{{ row.domain || 'Nessun dominio' }}</span>
                            </div>
                        </div>
                    </td>
                    <td>
                        <span *ngIf="agentLabel(row); else noAgentName">{{ agentLabel(row) }}</span>
                        <ng-template #noAgentName><span class="company-muted">Nessun agente</span></ng-template>
                    </td>
                    <td>
                        <span class="company-icon-badge" [ngClass]="companyStatusBadgeClass(row.status)">
                            <i class="bi" [ngClass]="companyStatusIcon(row.status)" aria-hidden="true"></i>
                            {{ companyStatusLabel(row.status) }}
                        </span>
                    </td>
                    <td>
                        <span class="company-icon-badge" [ngClass]="subscriptionBadgeClass(row)">
                            <i class="bi" [ngClass]="subscriptionIcon(row)" aria-hidden="true"></i>
                            {{ subscriptionLabel(row) }}
                        </span>
                    </td>
                    <td class="company-col-actions" (click)="$event.stopPropagation()">
                        <div class="company-actions">
                            <a class="btn welldone-btn-gray" title="Apri società" [routerLink]="['/companies/' + row.id + '/settings']">
                                <i class="bi bi-box-arrow-up-right" aria-hidden="true"></i>
                            </a>
                            <button
                                *ngIf="isSuperAdmin()"
                                type="button"
                                class="btn welldone-btn-gray"
                                title="Crea record DNS"
                                (click)="createDomainRecord(row)"
                            >
                                <i class="bi bi-globe" aria-hidden="true"></i>
                            </button>
                            <button
                                *ngIf="row.status === 'pendingOnboarding' && isSuperAdmin()"
                                type="button"
                                class="btn welldone-btn-light"
                                title="Invia onboarding"
                                (click)="sendApprovalEmail(row.id)"
                            >
                                <i class="bi bi-envelope" aria-hidden="true"></i>
                            </button>
                        </div>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="loadingbody">
                <tr *ngFor="let row of skeletonRows">
                    <td>
                        <div class="company-identity">
                            <div class="company-skel company-skel-mark"></div>
                            <div class="company-identity-text">
                                <div class="company-skel company-skel-title"></div>
                                <div class="company-skel company-skel-line"></div>
                            </div>
                        </div>
                    </td>
                    <td><div class="company-skel company-skel-company"></div></td>
                    <td><div class="company-skel company-skel-chip"></div></td>
                    <td><div class="company-skel company-skel-chip"></div></td>
                    <td class="company-col-actions">
                        <div class="company-actions">
                            <div class="company-skel company-skel-btn"></div>
                            <div class="company-skel company-skel-btn"></div>
                        </div>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="5" class="company-empty">Nessuna società trovata. Prova a cambiare ricerca o filtri.</td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</ng-template>
